import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { colors, globals } from '../../styles';
import { TabProps } from './props';

class Tab extends React.Component<TabProps, any> {
  public render() {
    const { text, onClick, className } = this.props;

    return (
      <button onClick={onClick} className={className}>
        {text}
      </button>
    );
  }
}

const StyledTab = styled(Tab)`
  ${globals.button};

  align-items: center;
  border: none;
  border-radius: 0;
  border-right: 1px solid ${colors.grey50};
  color: ${colors.black};
  cursor: pointer;
  display: flex;
  font-size: 100%;
  height: 42px;
  justify-content: center;
  padding: 0 1rem;
  text-decoration: none;
  flex-grow: 1;
  overflow: hidden;
  flex-basis: min-content;
  text-align: center;

  &.active {
    background-color: ${colors.grey200};
    outline: none;
  }
  :not(.active):focus,
  :not(.active):hover {
    background-color: ${colors.grey50};
    outline: none;
  }
  :last-child {
    border-right: none;
  }
`;

export default StyledTab;
